<template>
  <el-dialog title="充值VIP" width="500px" :visible.sync="formVisible" :close-on-click-modal="false" @close="closeFun">
    <div>
      <div class="contDiv">
        <div style="width:50%">
          <div class="tits">VIP 1</div>
          <div class="pay-wars">目前仅支持余额扣款!!!</div>
          <div class="conts">2 TB</div>
          <div class="tips"><el-button class="chongBtn" type="warning" :loading="submiting"
              @click="chongVipFun(1, 1)">15元/月</el-button></div>
          <div class="tips"><el-button class="chongBtn" type="danger" :loading="submiting"
              @click="chongVipFun(1, 12)">150元/年</el-button></div>
        </div>
        <div style="width:50%">
          <div class="tits">VIP 2</div>
          <div class="pay-wars">目前仅支持余额扣款!!!</div>
          <div class="conts">5 TB</div>
          <div class="tips"><el-button class="chongBtn" type="warning" :loading="submiting"
              @click="chongVipFun(2, 1)">30元/月</el-button></div>
          <div class="tips"><el-button class="chongBtn" type="danger" :loading="submiting"
              @click="chongVipFun(2, 12)">300元/年</el-button></div>

        </div>
      </div>
      <div class="infotxts">
        <ul>
          <li>空间大小会随<span style="color:#fd8f1c">上个月收入而变化</span>: !</li>
          <li>默认为 <span style="color:red">50GB</span> ! ! !</li>
          <li>如果上个月收入大于 <span style="color:#f60">500</span>,则空间为 <span style="color:red">100GB</span> !</li>
          <li>如果上个月收入大于 <span style="color:#f60">1000</span>,则空间为 <span style="color:red">200GB</span> !</li>
          <li>如果上个月收入大于 <span style="color:#f60">2000</span>,则空间为 <span style="color:red">300GB</span> !</li>
        </ul>
      </div>
    </div>
    <!--工具条-->
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click.native="formVisible = false">取消</el-button>
      <el-button type="primary" @click="onWaitFun(false)" :loading="formLoading">我已扫码完成</el-button>
    </div> -->
  </el-dialog>
</template>


<script>
export default {
  data () {
    return {
      formVisible: false,
      formLoading: false,
      submiting: false,
    }
  },
  methods: {
    close () {
      if (this.formVisible == true)
        this.formVisible = false;
    }, show () {
      this.formVisible = true;

    }, closeFun (e) {
      // console.log('closeFun', e);
      this.$emit('close');
    }, chongVipFun (lev, mon) {
      if (this.submiting)
        return;
      this.$confirm('确定充值吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.submiting = true;
        this.$post('/user/vip', { lev: lev, mon: mon }).then(res => {
          this.$emit('submitOK');
          this.submiting = false;
          this.formLoading = true;
          this.formVisible = false;
          this.$message({
            message: '充值成功!!',
            type: 'success'
          });
        }).catch(err => {
          this.submiting = false;
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
.contDiv {
  text-align: center;
  margin: 20px;
  display: flex;

  .tits {
    font-size: 20px;
    border: solid 1px #f60;
    border-radius: 8px;
    margin: 10px;
    padding: 8px;
  }

  .pay-wars {
    color: #fd8f1c;
    font-size: 14px;
  }

  .conts {
    font-weight: bold;
    font-size: 25px;
    color: #f60;
    padding: 35px;
  }

  .chongBtn {
    font-size: 18px;
    // color:#f60;
    margin: 5px 0;
  }
}

.infotxts {
  color: #a1a1a1;
  border-top: 1px solid #b9bbbe;
  padding: 10px;
  text-align: left;
}

.infotxts ul {
  margin: 10px;
  padding: 0;
  list-style: decimal;
}

.infotxts ul li {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// ChongVip.vue?ae3c3792